import React from "react";
import PropTypes from "prop-types";

const SvgComponent = (props) => {
	const {
		color,
	} = props;

	const defaultColor = "#0B060D";
	return (
		<svg width={24} height={24} {...props}>
			<path
				d="M12 4L5 19.384l.638.616L12 17.539 18.365 20l.635-.616L12 4zm0 3.777v8.044l-.547.21-3.895 1.508L12 7.777z"
				fill={color || defaultColor}
				fillRule="nonzero"
			/>
		</svg>
	);
};

SvgComponent.propTypes = {
	color: PropTypes.string,
};

SvgComponent.defaultProps = {
	color: "#0b060d",
};

export default SvgComponent;
